<template>
  <div>
    <AppHeader title="实验记录备注"/>

    <!-- 添加备注表单 -->
    <div class="remark-form">
      <Panel title="添加备注">
        <div slot="content">
          <div class="form-item">
            <label><span class="required">*</span>备注类型</label>
            <select v-model="newRemark.code" class="form-control">
              <option value="">请选择类型</option>
              <option v-for="type in remarkTypes" :key="type.value" :value="type.value">
                {{ type.label }}
              </option>
            </select>
          </div>

          <div class="form-item">
            <label><span class="required">*</span>备注内容</label>
            <textarea v-model="newRemark.body" class="form-control" placeholder="请输入备注内容" rows="3"></textarea>
          </div>

          <div class="form-item">
            <label>备注附件 <span class="label-tip">（最多支持8张图片）</span></label>
            <FileUpload :space="space" :biz="biz" :biz-id="experimentId" :editable="true" :max-size="8" ref="fileUpload"/>
          </div>

          <button class="btn green" @click="saveRemark">提交</button>
        </div>
      </Panel>
    </div>

    <!-- 备注列表 -->
    <div class="remark-list">
      <Panel title="备注列表">
        <div slot="content">
          <div class="line" v-for="remark in remarks" :key="remark.id">
            <div class="remark-header">
              <span class="remark-time">{{ formatDate(remark.createAt) }}</span>
              <span class="remark-type">{{ remark.type || remark.code }}</span>
            </div>
            <div class="remark-content">{{ remark.body }}</div>
            <div class="remark-files" v-if="remark.files && remark.files.length > 0">
              <img v-for="file in remark.files" :key="file.uuid" :src="toImgUrl(file.uuid)" @click="previewImage(file.uuid)" class="remark-file-img"/>
            </div>
            <div class="remark-footer">
              <span class="remark-user">{{ getRemarkUser(remark) }}</span>
              <a class="remark-del" @click="deleteRemark(remark.id)" v-if="remark.code !== '时长调整'">删除</a>
            </div>
          </div>
          <div class="line text-center" v-if="remarks.length === 0">暂无备注</div>
        </div>
      </Panel>
    </div>

    <!-- 图片预览弹窗 -->
    <mt-popup v-model="previewPopShow" position="center" class="preview-popup">
      <img :src="previewUrl" @click="previewPopShow = false"/>
    </mt-popup>
  </div>
</template>

<style lang="scss" scoped>
.remark-form {
  margin: 10px 0;

  .form-item {
    margin-bottom: 15px;

    label {
      display: block;
      margin-bottom: 5px;
      font-size: 14px;
      color: #666;

      .required {
        color: #ff4757;
        margin-right: 2px;
      }

      .label-tip {
        font-size: 12px;
        color: #999;
      }
    }

    .form-control {
      width: 100%;
      padding: 8px;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 14px;
      box-sizing: border-box;
    }

    textarea.form-control {
      resize: vertical;
      min-height: 80px;
    }
  }
}

.remark-list {
  margin: 10px 0;

  .remark-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;

    .remark-time {
      font-size: 12px;
      color: #999;
    }

    .remark-type {
      font-size: 12px;
      color: #4A89DC;
      padding: 2px 8px;
      background: #e8f4ff;
      border-radius: 3px;
    }
  }

  .remark-content {
    font-size: 14px;
    color: #333;
    line-height: 1.6;
    margin-bottom: 8px;
    word-wrap: break-word;
  }

  .remark-files {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;

    .remark-file-img {
      width: 60px;
      height: 60px;
      object-fit: cover;
      border-radius: 4px;
      border: 1px solid #ddd;
      cursor: pointer;
    }
  }

  .remark-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .remark-user {
      font-size: 12px;
      color: #666;
    }

    .remark-del {
      font-size: 12px;
      color: #ff4757;
      cursor: pointer;
    }
  }
}

.btn.green {
  width: 100%;
  height: 40px;
  background: #1AAD19;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: #FFFFFF;
  border: 0;
  margin-top: 10px;
}

.preview-popup {
  background: rgba(0, 0, 0, 0.8);
  padding: 10px;
  border-radius: 4px;

  img {
    max-width: 80vw;
    max-height: 80vh;
    object-fit: contain;
  }
}
</style>

<script>
import AppHeader from "@/components/AppHeader";
import Panel from "@/components/Panel";
import FileUpload from "@/components/FileUpload";
import { Toast, MessageBox } from 'mint-ui';

export default {
  components: {
    AppHeader,
    Panel,
    FileUpload
  },
  data() {
    return {
      experimentId: null,
      remarks: [],
      remarkTypes: [],
      space: 'publicFile',
      biz: 70,
      remarkBiz: 3000, // Biz.REMARK
      newRemark: {
        biz: 70, // EXPERIMENT
        bizId: null,
        code: '',
        body: ''
      },
      previewPopShow: false,
      previewUrl: ''
    }
  },
  mounted() {
    this.experimentId = this.$route.query.id
    if (!this.experimentId) {
      Toast('缺少实验ID参数')
      return
    }
    this.newRemark.bizId = this.experimentId
    this.loadRemarkTypes()
    this.loadRemarks()
  },
  methods: {
    // 加载备注类型字典
    loadRemarkTypes() {
      this.$http.get('/api/dict?key=remark_types&queryAll=false').then(res => {
        if (res && res.results && res.results.length > 0) {
          this.remarkTypes = res.results.map(item => ({
            value: item.id,
            label: item.text
          }))
          // 默认选择"默认类型"
          const defaultType = this.remarkTypes.find(t => t.label === '默认类型')
          if (defaultType) {
            this.newRemark.code = defaultType.value
          }
        }
      })
    },

    // 加载备注列表
    loadRemarks() {
      const params = new URLSearchParams()
      params.append('biz', 70)
      params.append('bizId', this.experimentId)
      params.append('page', 1)
      params.append('size', 100)

      this.$http.post('/portal/remark/query', params).then(res => {
        if (res.success && res.data) {
          // 分页数据在 content 中
          this.remarks = res.data.content || res.data || []
          // 为每个备注加载附件
          this.remarks.forEach(remark => {
            this.loadRemarkFiles(remark)
          })
        }
      })
    },

    // 加载备注附件
    loadRemarkFiles(remark) {
      this.$http.get(`/fs/list?space=${this.space}&biz=${this.remarkBiz}&bizId=${remark.id}`, { autoToast: false, indicator: false }).then(res => {
        if (res.success && res.data) {
          this.$set(remark, 'files', res.data)
        }
      }).catch(() => {})
    },

    // 保存备注
    saveRemark() {
      if (!this.newRemark.code) {
        Toast('请选择备注类型')
        return
      }
      if (!this.newRemark.body || !this.newRemark.body.trim()) {
        Toast('请输入备注内容')
        return
      }

      // 获取附件fids
      const fids = this.$refs.fileUpload ? this.$refs.fileUpload.getFids() : []

      const params = new URLSearchParams()
      params.append('biz', this.newRemark.biz)
      params.append('bizId', this.newRemark.bizId)
      params.append('code', this.newRemark.code)
      params.append('body', this.newRemark.body.trim())
      params.append('fids', fids.join(','))

      this.$http.post('/portal/remark/save', params).then(res => {
        if (res.success) {
          Toast('保存成功')
          // 清空表单，类型重置为默认类型
          const defaultType = this.remarkTypes.find(t => t.label === '默认类型')
          this.newRemark.code = defaultType ? defaultType.value : ''
          this.newRemark.body = ''
          // 清空附件组件
          if (this.$refs.fileUpload) {
            this.$refs.fileUpload.fileHolders = []
            this.$refs.fileUpload.appendAddIfPossible()
          }
          // 重新加载列表
          this.loadRemarks()
        } else {
          Toast(res.msg || '保存失败')
        }
      }).catch(err => {
        Toast('保存失败')
      })
    },

    // 删除备注
    deleteRemark(id) {
      MessageBox.confirm('确定要删除这条备注吗？').then(() => {
        this.$http.post(`/portal/remark/remove?id=${id}`).then(res => {
          if (res.success) {
            Toast('删除成功')
            this.loadRemarks()
          } else {
            Toast(res.msg || '删除失败')
          }
        }).catch(err => {
          Toast('删除失败')
        })
      }).catch(() => {
        // 用户取消
      })
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return ''
      return this.$moment(timestamp).format('YYYY-MM-DD HH:mm')
    },

    // 获取备注人信息
    getRemarkUser(remark) {
      if (remark.user && remark.user.realName) {
        return remark.user.realName
      }
      if (remark.user && remark.user.name) {
        return remark.user.name
      }
      if (remark.modifier) {
        return '用户' + remark.modifier
      }
      return '未知'
    },

    // 生成图片URL
    toImgUrl(uuid) {
      return `${this.imgUrl}/${uuid}`
    },

    // 预览图片
    previewImage(uuid) {
      this.previewUrl = this.toImgUrl(uuid)
      this.previewPopShow = true
    }
  }
}
</script>
